import { useEffect } from "react";
import {
	hasPluginPermission,
	isCustomer,
	isFinance,
	isFinanceAdmin,
	isMainUserLimited,
	isMasterdata,
	isOperator,
	isRTR,
	isSkipper,
	isTerminal,
	Plugin,
} from "imports/Utils";
import { CircularProgress, Paper } from "@mui/material";
import { useStoreState, Session } from "ezStore";
import { useNavigate } from "react-router-dom";
import { isShipManager, isTankmatch } from "components/utils/Permission";

const LandingPageUrl = {
	INDEX: "/",
	USER: "/view/user",
	USERS: "/view/users",
	CONTROL_TOWER_LIST: "/view/controltower/list",
	SKIPPER_VOYAGE: "/view/skipper/voyage",
	VOYAGES: "/view/voyages",
	CARGOS: "/view/cargos",
	CALLS: "/view/calls",
	LOCATIONS: "/view/locations",
	DECLARATIONS: "/view/declarations/purchase",
	SHIP_PLANNING: "/view/planning/ships",
};

const getSkipperLandingPageUrl = (session: Session) => {
	if (hasPluginPermission(session, Plugin.SKIPPER_DASHBOARD)) {
		return LandingPageUrl.SKIPPER_VOYAGE;
	}
	if (hasPluginPermission(session, Plugin.USE_CONTAINERS)) {
		return LandingPageUrl.CALLS;
	}
	return LandingPageUrl.VOYAGES;
};

const getRtrOrMainUserLimitedLandingPageUrl = (session: Session) => {
	if (isTankmatch(session)) {
		return LandingPageUrl.SHIP_PLANNING;
	}
	return LandingPageUrl.CONTROL_TOWER_LIST;
};

export function LandingPage() {
	const session = useStoreState(store => store.session);
	const navigate = useNavigate();

	const getLandingPageUrl = () => {
		if (isRTR(session) || isMainUserLimited(session)) {
			return getRtrOrMainUserLimitedLandingPageUrl(session);
		}
		if (isSkipper(session)) {
			return getSkipperLandingPageUrl(session);
		}
		if (isCustomer(session)) {
			return LandingPageUrl.CARGOS;
		}
		if (isShipManager(session) || isOperator(session)) {
			return LandingPageUrl.VOYAGES;
		}
		if (isMasterdata(session)) {
			return LandingPageUrl.USERS;
		}
		if (isTerminal(session)) {
			return LandingPageUrl.LOCATIONS;
		}
		if (isFinance(session) || isFinanceAdmin(session)) {
			return LandingPageUrl.DECLARATIONS;
		}
		return null;
	};

	useEffect(() => {
		if (session.settings) {
			const landingPageUrl = getLandingPageUrl();
			if (landingPageUrl !== null) {
				navigate(landingPageUrl);
			}
		}

	}, [ session ]);

	return (
		<Paper
			square
			sx={{
				height: "100%",
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<CircularProgress color="primary" size={30} />
		</Paper>
	);
}
